import React, { Component, useEffect, useState } from "react";
import MapBox from "../../components/MapBox";
import defaultImg from "../../assets/images/1.svg";
import "react-circular-progressbar/dist/styles.css";
import ReactTable from "react-table";
import Api from "../../services/api";
import { colorScale } from "../../utils";
import "./style.css";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  Col,
  FormGroup,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import ProgressBar from "../../components/ProgressBar";
import ReactExport from "react-export-excel";
import CustomTable from "../../components/CustomTable";
import MapCustomTable from "./table";
import { toast } from "react-toastify";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const columns = [
  {
    Header: " प्रदेशको नाम",
    accessor: "name",
  },
  {
    Header: "कुल मन्त्रालय",
    accessor: "total_ministry",
  },
  {
    Header: "प्रकासित संख्या",
    accessor: "published_ministry",
  },
  {
    Header: "अधिक्तम प्राप्तांक",
    accessor: "highest_marks",
  },
  {
    Header: "न्युनतम प्राप्तांक",
    accessor: "lowest_marks",
  },
  {
    Header: "प्रतिशत(%)",
    id: "ministry_percentage",
    accessor: (d) => {
      return `${d.ministry_percentage}%`;
    },
  },
];

const columns1 = [
  {
    Header: " प्रदेशको नाम",
    accessor: "name",
  },
];

const getImage = (icon) => {
  try {
    let test = require(`../../assets/icons/${icon}`);
    return test;
  } catch (error) {
    return defaultImg;
  }
};

const Card = ({ Icon, title, value, percentage }) => {
  return (
    <div className="bg-white rounded shadow-sm col-12 mb-2 px-0">
      <div
        className="col d-flex justify-content-between my-2"
        style={{ alignItems: "center" }}
      >
        <p className="card-title m-0 p-0">{title}</p>
        <p className="card-text">{value}</p>
      </div>

      <ProgressBar
        bgcolor={colorScale(percentage)}
        progress={percentage}
        height={10}
      />
    </div>
  );
};

function MapPage() {
  const [activeTab, setActiveTab] = useState(0);
  const [province, setProvince] = useState([]);
  const [provinceData, setProvinceData] = useState([]);
  const [ocmcm_table, setOcmcmTableData] = useState([]);
  const [fyList, setFyList] = useState([]);
  const [yektable, setyektable] = useState(null);
  const [fiscalYearId, setFiscalYearId] = useState(
    localStorage.getItem("fiscalYear") ? localStorage.getItem("fiscalYear") : 4
  );
  const [ministryLevel, setMinistryLevel] = useState(false);

  const getProvince = async () => {
    let response = await Api.getProvinceList();
    setProvince(response.response);
  };

  const getProvinceData = async () => {
    if (ministryLevel) {
      setProvinceData([]);
    } else {
      let response = await Api.getProvinceData(fiscalYearId);
      setProvinceData(response.response.province_list);
    }
  };

  const import2Excel = () => {
    let excelColumns = [
      <ExcelColumn key={"name"} label="प्रदेश" value="name" />,
      <ExcelColumn
        key={"total_ministry"}
        label="कुल मन्त्रालय"
        value="total_ministry"
      />,
      <ExcelColumn
        key={"published_ministry"}
        label="प्रकासित संख्या"
        value="published_ministry"
      />,
      <ExcelColumn
        key={"highest_marks"}
        label="अधिक्तम प्राप्तांक"
        value="highest_marks"
      />,
      <ExcelColumn
        key={"lowest_marks"}
        label="न्युनतम प्राप्तांक"
        value="lowest_marks"
      />,
      <ExcelColumn
        key={"ministry_percentage"}
        label="प्रतिशत(%)"
        value="ministry_percentage"
      />,
    ];
    if (provinceData.length > 0) {
      return (
        <ExcelFile
          element={
            <button className="btn btn-primary" style={{ marginRight: 10 }}>
              डाउनलोड
            </button>
          }
        >
          <ExcelSheet data={provinceData} name="प्रदेश तथ्याड़क">
            {excelColumns}
          </ExcelSheet>
        </ExcelFile>
      );
    }
  };

  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("user"));
    let fiscalYear = localStorage.getItem("fiscalYear");
    setFiscalYearId(
      fiscalYear
        ? fiscalYear
        : user && user.user && user.user.fiscal_year_id
        ? user && user.user && user.user.fiscal_year_id
        : 3
    );
    getProvince();
    _getFiscalyear();
    getProvinceData();
  }, [ministryLevel]);
  const yekdashboard = async () => {
    setMinistryLevel(true);
    const response = await Api.getOcmcmProvinceData(fiscalYearId);
    setProvinceData(response.response.ocmcm_list);
    const r = await Api.getOcmcmHomeYekData(fiscalYearId);
    setyektable(r.response);
    console.log(r.response);
  };
  const ministrydashboard = async () => {
    setMinistryLevel(false);
    if (ministryLevel) {
      setProvinceData([]);
    } else {
      let response = await Api.getProvinceData(fiscalYearId);
      setProvinceData(response.response.province_list);
    }
  };

  const _getFiscalyear = async () => {
    let fyList = await Api.getFyList();
    console.log(fyList);
    setFyList(fyList.response);
  };
  const _handleFiscalYearChange = async (e) => {
    e.preventDefault();
    if (e.target) {
      localStorage.setItem("fiscalYear", e.target.value);
      if (!ministryLevel) {
        let response = await Api.getProvinceData(
          localStorage.getItem("fiscalYear")
        );
        setProvinceData(response.response.province_list);
      } else {
        const respo = await Api.getOcmcmProvinceData(
          localStorage.getItem("fiscalYear")
        );
        setProvinceData(respo.response.ocmcm_list);
        let response = await Api.getOcmcmHomeYekData(
          localStorage.getItem("fiscalYear")
        );
        setyektable(response.response);
      }
    } else {
      toast.error("Error occured");
    }
  };

  class CustomLabel extends Component {
    render() {
      const { x, y, value } = this.props;
      return (
        <text
          x={x}
          y={y}
          dy={-5}
          dx={20}
          fontSize="16"
          fontFamily="sans-serif"
          fill={"#008080"}
          textAnchor="right"
        >
          {value}
          {console.log("value", typeof value)}
        </text>
      );
    }
  }

  return (
    <>
      {/* <div className='d-flex align-items-center pb-2'>
                <label class="switch">
                    <input type="checkbox" onClick={(e) => setMinistryLevel(e.target.checked)} checked={ministryLevel} />
                    <span class="slider round">
                    </span>
                </label>
                <p className='heading p-0 m-0 pl-2'>{ministryLevel ? "एकीकृत लेखाजोखा" : "मन्त्रालयगत वित्तीय सुशासन लेखाजोखा"}</p>
            </div> */}
      <div className="flex-1">
        <div className="switchcontent">
          <p
            className={ministryLevel ? "m-0 p-2 activecontent1" : "m-0 p-2"}
            style={{ borderRight: "1px solid #b3b1b1", cursor: "pointer" }}
            onClick={() => yekdashboard()}
          >
            एकीकृत
          </p>
          <p
            className={ministryLevel ? "m-0  p-2" : "m-0 p-2 activecontent2"}
            onClick={() => ministrydashboard()}
            style={{ cursor: "pointer" }}
          >
            मन्त्रालय
          </p>
        </div>
        <div className="d-flex justify-content-between">
          <FormGroup>
            <Input
              type="select"
              name="fselect"
              id="fiscalYearSelect"
              value={localStorage.getItem("fiscalYear")}
              onChange={(e) => _handleFiscalYearChange(e)}
            >
              <option value={0} defaultValue selected>
                आर्थिक वर्ष चयन गार्नुहोस
              </option>
              {fyList.length > 0 &&
                fyList.map((fy, index) => {
                  return (
                    <option key={fy.id} value={fy.id}>
                      आर्थिक वर्ष {fy.name}
                    </option>
                  );
                })}
            </Input>
          </FormGroup>
        </div>
      </div>
      <div className="d-flex ">
        <div className="col-9 bg-white rounded mr-2 shadow-sm">
          <MapBox value={""} />
        </div>
        <div className="col-3">
          <div className="d-flex flex-wrap">
            {!ministryLevel &&
              provinceData &&
              provinceData.map((item, index) => (
                <Card
                  key={item.name}
                  Icon={getImage("province_icon.svg")}
                  title={item.name}
                  value={`${item.published_ministry}/ ${item.total_ministry}`}
                  percentage={item.ministry_percentage}
                />
              ))}
            {ministryLevel &&
              provinceData &&
              provinceData
                .sort((a, b) => a.province_id - b.province_id)
                .map((item, index) => (
                  <Card
                    key={item.name}
                    Icon={getImage("province_icon.svg")}
                    title={item.province_name}
                    value={`${item.published_ocmcm}/ ${item.total_ocmcm}`}
                    percentage={item.ocmcm_percentage}
                  />
                ))}
          </div>
        </div>
      </div>

      <div className="d-flex my-4">
        <div className="col-3  mr-4 p-0">
          <p className="barheading">विषयगत तथ्याङक</p>
          <Nav
            vertical
            style={{ border: "none", margin: "none" }}
            className="bg-white pr-1"
          >
            {provinceData.map((tabData, index) => (
              <NavItem
                key={index}
                style={{ width: "100%", display: "flex", cursor: "pointer" }}
                onClick={() => {
                  setActiveTab(index);
                }}
              >
                <NavLink
                  className={`${
                    activeTab === index
                      ? "nav-link-purple-border px-4"
                      : "nav-link-ordinary px-3"
                  }`}
                >
                  {ministryLevel ? tabData.province_name : tabData.name}
                </NavLink>
                {activeTab === index && <div className="arrow-right" />}
              </NavItem>
            ))}
          </Nav>
        </div>
        <div className="col rounded bg-white ml-2">
          <TabContent activeTab={activeTab}>
            {provinceData.map((tabData, index) => (
              <TabPane key={index} tabId={index}>
                <div className="row">
                  <div className="col-12">
                    <ResponsiveContainer
                      ResponsiveContainer
                      width="100%"
                      height={450}
                    >
                      <BarChart data={tabData.categories}>
                        <CartesianGrid />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip position={{ x: 0, y: 0 }} />
                        <Legend />
                        <Bar
                          name="औसत"
                          dataKey="average_score"
                          fill="#008080"
                          label={<CustomLabel /> == "0" ? "" : <CustomLabel />}
                        />
                        <Bar
                          name="पुर्णाक"
                          dataKey="total_score"
                          fill="#66CCCC"
                          label={<CustomLabel /> == "0" ? "" : <CustomLabel />}
                        />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </TabPane>
            ))}
          </TabContent>
        </div>
      </div>
      {!ministryLevel ? (
        <div className="my-3 bg-white p-4 border-rounded shadow-sm">
          <div className="d-flex justify-content-between">
            <p classname="heading" style={{ fontSize: "30px" }}>
              प्रदेश तथ्याड़क
            </p>
            <div>{import2Excel()}</div>
          </div>
          <div>
            <ReactTable
              data={ministryLevel ? ocmcm_table : provinceData}
              columns={ministryLevel ? columns1 : columns}
              defaultPageSize={7}
              showPagination={false}
              className=" -striped -highlight text-center"
            />
          </div>
        </div>
      ) : (
        <div className="my-3 bg-white p-4 border-rounded shadow-sm">
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            {yektable &&
              yektable.map((p, index) => (
                <MapCustomTable
                  categories={yektable[index]}
                  title={"अधिकतम नतिजा प्राप्त गर्ने "}
                  index={index + 1}
                />
              ))}
          </div>
        </div>
      )}
    </>
  );
}

export default MapPage;
